module.exports = __webpack_public_path__ + "img/case-medical.8f4e5035.png";